<template>
  <div class="app">
    <AppHeader fixed>
      <b-link class="navbar-brand" to="/">
        <img
          class="navbar-brand-full d-md-down-none"
          src="@/../public/img/brand/entirelogo.svg"
          width="89"
          height="25"
          alt="Carlbot logo"
        />
        <img
          class="navbar-brand-minimized"
          src="@/../public/img/brand/googleturtle.svg"
          width="30"
          height="30"
          alt="Carlbot logo"
        />
      </b-link>
      <b-navbar-nav class="d-md-down-none nav-title">
        <b-nav-item class="px-2" href="https://docs.carl.gg/">
          <i class="fas fa-book mr-1"></i>Docs
        </b-nav-item>
        <b-nav-item
          class="px-2"
          href="https://discord.com/oauth2/authorize?&client_id=235148962103951360&scope=applications.commands+bot&permissions=2088234230&response_type=code&redirect_uri=https://carl.gg/api/server_auth"
          exact
        >
          <i class="fas fa-plus mr-1"></i>Invite
        </b-nav-item>
        <b-nav-item class="px-2" href="https://discord.gg/S2ZkBTnd8X">
          <i class="fab fa-discord mr-1"></i>Discord
        </b-nav-item>
        <b-nav-item class="px-2" to="/status">
          <i class="fas fa-heartbeat mr-1"></i>Status
        </b-nav-item>
        <b-nav-item class="px-2 premium-nav-cta" href="/get-premium">
          <span class="premium-nav-cta__inner">
            <i class="fas fa-crown"></i> Premium
          </span>
        </b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="d-lg-none nav-title nav-icons">
        <b-nav-item to="/">
          <i class="fas fa-home"></i>
        </b-nav-item>
        <b-nav-item href="https://docs.carl.gg/">
          <i class="fas fa-book"></i>
        </b-nav-item>
        <b-nav-item
          href="https://discord.com/oauth2/authorize?&client_id=235148962103951360&scope=applications.commands+bot&permissions=2088234230&response_type=code&redirect_uri=https://carl.gg/api/server_auth"
          exact
        >
          <i class="fas fa-plus"></i>
        </b-nav-item>
        <b-nav-item href="https://discord.gg/S2ZkBTnd8X" class="d-sm-down-none">
          <i class="fab fa-discord"></i>
        </b-nav-item>
        <b-nav-item to="/status">
          <i class="fas fa-heartbeat"></i>
        </b-nav-item>
        <b-nav-item href="/get-premium" class="premium-nav-cta premium-nav-cta--icon">
          <span class="premium-nav-cta__inner">
            <i class="fas fa-crown"></i>
          </span>
        </b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <div v-if="logged_in">
          <DefaultHeaderDropdownAccnt />
        </div>
        <div v-else class="mr-auto">
          <b-button
            style="
              background-color: #3a4149;
              border-color: #eee;
            "
            v-on:click="login"
            class="px-md-3 btn-pill dark mr-md-2 "
            >Login</b-button
          >
        </div>
      </b-navbar-nav>
      <!--<AsideToggler class="d-lg-none" mobile />-->
    </AppHeader>
    <div class="app-body onboarding__background">
      <aside class="onboarding__sidenav d-md-down-none" v-if="showSide">
        <div class="onboarding__sidenav-inner">
          <div class="onboarding__sidenav-eyebrow">
            <i class="fas fa-rocket"></i> Quick Setup
          </div>
          <h2 class="onboarding__sidenav-title">
            Configure Carl-bot
          </h2>
          <p class="onboarding__sidenav-lede" v-if="current_guild">
            for <strong>{{ current_guild.name }}</strong>
          </p>

          <ol class="onboarding__steps">
            <li
              v-for="(el, idx) in progress"
              :key="el.name"
              class="onboarding__step"
              :class="{
                'onboarding__step--done': idx < currentStep,
                'onboarding__step--current': idx === currentStep,
              }"
            >
              <div class="onboarding__step-marker">
                <i v-if="idx < currentStep" class="fas fa-check"></i>
                <span v-else>{{ idx + 1 }}</span>
              </div>
              <div class="onboarding__step-label">{{ el.name }}</div>
            </li>
          </ol>
        </div>
      </aside>
      <main class="main" style="margin-left: 0px">
        <div style="position: relative; z-index: 1">
          <router-view></router-view>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import { Header as AppHeader } from "@coreui/vue";
import DefaultHeaderDropdownAccnt from "./DefaultHeaderDropdownAccnt";

export default {
  name: "DefaultContainer",
  components: {
    AppHeader,
    DefaultHeaderDropdownAccnt
  },
  data() {
    return {
      discord_user: {},
      imageUrl: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACtUlEQVR4nO1YS2sTURg9WnQjig9EETe+cJ0qqAt3rdKAIi58gcUudKELf4HiRpe+8A/UZRApSN0Iumht5vuSqAtBBVG6EJWmZO6dVoNor9whr2beqWYmOgcOhJm55zvnm/tgAqRIkSJFiqRCKSzXRC9CMo5LxqxklPVv9BIqBrZJwpxkKE3B+GaWsBO9AKWwTBCe1M03QhCe6XtIOiTjQrv5Bgnn/05RA8ck46MgvBEFZDvVmS9hiySYPgEq+plO9UUBWe3R9so4al9UOfRp4ZZXvSAI1/X1yAUIY57mm/pjUXVVDn2CcEN7a9GatXe42s2qoxDjqZXHprBFLMKJIPN16mfD6s4RNmsvLo2oNrZoSTBcu8X4ajEGgooIwgbB+BI2gCDMyBfYGKQrDRwUhE8eOvnmg4w7nsUYPwXhmt+BJAn3w5pv4ajvTsa4LAg/fNbT7cYAk3AmRMFH5hTWO7rPGOrAfL05R9r1ygbWCMKDoLGmgdPNAEXsCFWUMC2K2Fcf9/kVVknGh04DSML0zCRW1/UqjIwkvA8z1mRsX/zK9LwMN3+r+vXa3Sfc69h8k3dtLQPD+sQOOabsOBQlYTxi9x4Lwq+lBhBaI3rtcedCZFz9A93sDglXHAFMwuHYjXE4mgYOOQJUXmJt20mXSArCgjmBda77r2S864Hp89bV/BIOpG5z1DOAxbiUAIMqgBc9A5iEvQkwqPxoGtjjGUAVsSLCYdJ1CsZ39RorPQPUFvJU3EalFwnPfc3XFvKtBAe4GRjAYpyK3Si702KcDAxwYOhsqX9wRCWR+7PDhcAAmYGRybiN9nswM3huIjCAvQ4SMF2kC0OZ/1cCyLjNynYSzNABBONh7IZ5MfV3cpQAu2v/LKuEcFbksQtRMG9gq2DkJEPEaFzozkc2nyJFihQp/hv8Bs9/K/wQGZy+AAAAAElFTkSuQmCC',
      progress: [
        { name: "General" },
        { name: "Welcome Message" },
        { name: "Reaction Roles" },
        { name: "Moderation" },
        { name: "Automod" },
      ],
    };
  },
  methods: {
    login() {
      //window.location.href = "http://localhost:5000/api/login"
      window.location.href = window.location.origin +"/api/login";
    },
    updateAuthInfo(e) {
      if (e.data.discriminator != undefined) {
        this.$store.commit("login", e.data);
      }
      window.removeEventListener("message", this.updateAuthInfo);

      this.$router.push("/servers");
    }
  },
  computed: {
    currentStep() {
      return this.$store.state.onboardingStep;
    },
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched.filter(
        route => route.name || route.meta.label
      );
    },
    logged_in() {
      return Object.keys(this.$store.state.discord_user).length !== 0;
    },
    current_guild() {
      const guilds = this.$store.state.discord_guilds || [];
      return guilds.find((x) => x.id == this.$route.params.guild_id);
    },
    showSide() {
      const route = this.$route;
      return !route.path.endsWith("landing") && !route.path.endsWith("final");
    }
  },
  async created() {
    const guild_id = this.$route.params.guild_id;
    const resp = await this.axios.get(`/api/v1/servers/${guild_id}/onboarding`);
    this.$store.commit("syncOauth", resp.data);
  }
};
</script>

<style>
/* ---------- Layout chrome ---------- */
.onboarding__background {
  background: #22222a;
  color: #fefefe;
  font-family: "Poppins", "Roboto", sans-serif;
}

.onboarding__sidenav {
  width: 320px;
  min-height: calc(100vh - 55px);
  background: rgba(255, 255, 255, 0.02);
  border-right: 1px solid rgba(255, 255, 255, 0.06);
  flex-shrink: 0;
}
.onboarding__sidenav-inner {
  padding: 40px 32px;
  position: sticky;
  top: 55px;
}
.onboarding__sidenav-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  background: rgba(248, 203, 0, 0.12);
  border: 1px solid rgba(248, 203, 0, 0.4);
  color: #f8cb00;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  border-radius: 999px;
  margin-bottom: 14px;
}
.onboarding__sidenav-eyebrow i {
  font-size: 10px;
}
.onboarding__sidenav-title {
  font-family: "Poppins", sans-serif;
  font-weight: 700;
  font-size: 22px;
  color: #fff;
  margin: 0 0 4px;
  letter-spacing: -0.3px;
}
.onboarding__sidenav-lede {
  font-size: 13px;
  color: #b8b6c8;
  margin: 0 0 28px;
}
.onboarding__sidenav-lede strong {
  color: #d8d6e0;
  font-weight: 600;
}

/* ---------- Progress steps ---------- */
.onboarding__steps {
  list-style: none;
  padding: 0;
  margin: 0;
}
.onboarding__step {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
  font-size: 14px;
  color: #888699;
  transition: color 0.15s ease;
}
.onboarding__step-marker {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.15);
  background: rgba(255, 255, 255, 0.02);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  flex-shrink: 0;
}
.onboarding__step--current {
  color: #fff;
  font-weight: 600;
}
.onboarding__step--current .onboarding__step-marker {
  background: rgba(158, 128, 255, 0.15);
  border-color: #9e80ff;
  color: #9e80ff;
}
.onboarding__step--done {
  color: #d8d6e0;
}
.onboarding__step--done .onboarding__step-marker {
  background: #9e80ff;
  border-color: #9e80ff;
  color: #fff;
}
.onboarding__step-label {
  font-family: "Poppins", sans-serif;
}

/* ---------- Step page chrome (consumed by step pages) ---------- */
.onboarding__container {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #22222a;
  flex-grow: 1;
  padding: 40px 24px 120px;
  gap: 22px;
}
.onboarding__eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  background: rgba(248, 203, 0, 0.12);
  border: 1px solid rgba(248, 203, 0, 0.4);
  color: #f8cb00;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  border-radius: 999px;
}
.onboarding__step-title {
  font-family: "Poppins", sans-serif;
  font-weight: 700;
  font-size: 28px;
  color: #fff;
  margin: 8px 0 0;
  letter-spacing: -0.3px;
  text-align: center;
}
.onboarding__step-lede {
  font-size: 14px;
  color: #b8b6c8;
  margin: 0;
  max-width: 560px;
  text-align: center;
}

/* Legacy classes still used by step pages — repurposed to the new look */
.gradient {
  background: #22222a;
}
.underlined__title {
  display: none;
}
.smalltitle.onboardingtitle,
.onboarding__container > h1.smalltitle {
  display: none;
}

/* ---------- Step card ---------- */
.onboarding__card.card {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 14px;
  color: #fefefe;
}
.onboarding__card .card-body {
  padding: 22px 24px;
}

@media only screen and (max-width: 960px) {
  .onboarding__card {
    width: 95vw !important;
  }
}
@media only screen and (min-width: 960px) {
  .onboarding__card {
    width: 620px !important;
    max-width: calc(100vw - 48px);
  }
}

/* ---------- Footer ---------- */
.onboarding__footer {
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  bottom: 0;
  background: rgba(34, 34, 42, 0.95);
  backdrop-filter: blur(8px);
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  padding: 14px 24px;
  z-index: 10;
}
@media only screen and (max-width: 960px) {
  .onboarding__footer {
    width: 100vw;
    left: 0;
  }
}
@media only screen and (min-width: 960px) {
  .onboarding__footer {
    width: calc(100vw - 320px);
    right: 0;
  }
}
</style>

<style scoped>
.nav-title .nav-link {
  font-family: "roboto";
  color: #fff;
}
.nav-icons i {
  font-size: 1.075rem;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect--active {
  z-index: 3 !important;
}

.multiselect,
.multiselect__input,
.multiselect__single {
  color: #eee !important;
}
.multiselect__input,
.multiselect__single {
  background: #515b65 !important;
  color: #fff !important;
  padding-left: 0px !important;
  padding-top: 2px !important;
  margin-bottom: 11px !important;
}
.multiselect__input::placeholder {
  color: #ddd !important;
  font-size: 14px;
}
.multiselect__tags {
  border: 1px solid #232823 !important;
  background: #515b65 !important;
}
.multiselect__tag {
  background: #2f353a !important;
  border-width: 1px !important;
  border-style: solid;
  border-radius: 500px;
  padding: 5px 10px 4px 26px !important;
  cursor: default;
}

.multiselect__option .multiselect__option--group {
  background-color: #2e343a !important;
  color: #eee;
}

.channelpicker__tag {
  border-radius: 6px !important;
  border-color: #eeeb !important;
}

.multiselect__tag-icon {
  left: -5px !important;
}

.multiselect__tag:hover .multiselect__tag-icon:after {
  content: "\D7";
  color: #fff;
  font-size: 14px;
  margin: -3.5px 0px 10px -4px;
  position: absolute;
}

.multiselect__tag-icon:after {
  content: "\D7";
  color: #fff0;
  font-size: 12px;
  margin: -3.5px 0px 10px -3.5px;
  position: absolute;
}

.multiselect__select:before {
  color: #2f353a !important;
  border-color: #2f353a transparent transparent !important;
}
.defaultcursor {
  cursor: default;
}
.multiselect__placeholder {
  color: #adadad !important;
}
.multiselect--active .multiselect__placeholder {
  color: #eee !important;
}
.multiselect__content-wrapper {
  background: #3a4149 !important;
  border: 1px solid #2f353a !important;
}
.multiselect--above .multiselect__content-wrapper {
  border-top: 1px solid #2f353a !important;
}
.multiselect__option--selected {
  background: #515b65 !important;
}

.fakediscord {
  border-radius: 50%;
  width: 15px;
  height: 15px;
  margin: 4px 10px 11px 9px;
  cursor: pointer;
}

.channelpicker_icon {
  background-color: #00000000 !important;
  border-radius: 0;
  border-width: 1px;
  border-style: none solid none none;
  border-color: #eeeb;
  width: 23px;
  height: 25px;
  margin: -1px -4px -20px 4px;
  padding-top: 5px;
}

.channelpicker_icon:after {
  content: "\D7";
  color: #999;
  font-size: 14px;
  margin: -3.5px 0px 10px -4px;
  position: absolute;
}

.multiselect__option--group {
  background-color: #2e343a !important;
  color: #eee !important;
}

.multiselect__option.multiselect__option--selected
  .option__desc
  .option__title {
  color: #bbb !important;
}

.multiselect__spinner {
  background: #515b65 !important;
}

.vc-sketch {
  background-color: #2f353a !important;
  position: absolute !important;
  z-index: 200;
}
.vc-sketch:active {
  user-select: none;
}

.vc-input__input {
  background-color: #515b65 !important;
  color: #eee !important;
  box-shadow: inset 0 0 0 1px #111 !important;
}
.vc-input__label {
  color: #eee !important;
}
.vc-sketch-alpha-wrap {
  display: none;
}
</style>
<style lang="scss">
.form-group-check {
  margin-top: 6px;
  margin-bottom: 6px;
  margin-right: 20px;
  margin-left: 20px;
  display: flex;
  // align-items: center;
  font-size: 16px;
  position: relative;
  flex-direction: column;
  align-items: flex-start;

  border-radius: 5px;
  
  color: #dcf7f9;

  label {
    display: flex;
    align-items: center;
  }

  input[type="checkbox"] {
    appearance: none;
    -webkit-appearance: none;

    height: 16px;
    width: 16px;
    border-radius: 2px;
    background: none;
    border: 2px solid #999999;
  }

  input[type="checkbox"]:checked {
    background: #9e80ff;
    border: none;
  }

  input[type="checkbox"]:hover {
    border: 2px solid #f2f2f2;
  }

  input[type="checkbox"] + .checker {
    path {
      fill: #00000000;
      stroke: #00000000;
    }

    margin-left: -19px;
  }

  input[type="checkbox"]:checked + .checker {
    path {
      fill: #dcf7f9;
      stroke: #dcf7f9;
    }
  }

  .checker,
  svg {
    // fill: #49d6df;
    fill: #00000000;
    stroke: #c5dde0;
    margin-right: 8px;
    width: 16px;
    height: 16px;
  }

  // Radio
  // The checker for the radio is a simple svg with 2 circles, one used wiht stroke and the other fill
  input[type="radio"] {
    appearance: none;
    -webkit-appearance: none;
    margin: 0;
  }

  input[type="radio"]:checked + .checker {
    fill: #9e80ff;
    stroke: #9e80ff;
  }

  input[type="radio"]:hover + .checker {
    stroke: #dcf7f9;
  }

  &-inner {
    display: flex;
  }

  .form-extras {
    margin-left: 26px;
  }
}
</style>

<style>
button.saucy-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 11px 24px;
  background: #9e80ff;
  color: #fff;
  border: none;
  border-radius: 999px;
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  text-decoration: none;
  transition: background 0.15s ease;
  line-height: normal;
}
.saucy-btn:hover {
  background: #b29bff;
  color: #fff;
  text-decoration: none;
}
.saucy-btn:disabled {
  background: rgba(158, 128, 255, 0.4);
  cursor: not-allowed;
}

.saucy-btn-alt {
  background: transparent;
  border: none;
  color: #c8c6d6;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  font-size: 13px;
  padding: 8px 12px;
  cursor: pointer;
  text-decoration: none;
  letter-spacing: 0.3px;
}
.saucy-btn-alt:hover {
  background: transparent;
  color: #fff;
}
.skip-btn {
  background: transparent;
  border: none;
  color: #888699;
  font-family: "Poppins", sans-serif;
  font-size: 12px;
  letter-spacing: 1px;
  text-transform: uppercase;
  cursor: pointer;
  padding: 8px 14px;
}
.skip-btn:hover {
  color: #c8c6d6;
}
</style>
